import { CodeSystem } from "@intocare/datatypes/lib/code-system";

export const OBSERVATION_LOCATION = {
	name: "OBSERVATION_LOCATION",
	concept: {
		BATHROOM: {
			display: {
				"nl-BE": "Badkamer",
				"fr-BE": "Salle de bain",
			},
		},
		COMMON_SPACE: {
			display: {
				"nl-BE": "Gemeenschappelijke ruimte",
				"fr-BE": "Espace commun",
			},
		},
		GARDEN: {
			display: {
				"nl-BE": "Tuin",
				"fr-BE": "Jardin",
			},
		},
		HALLWAY: {
			display: {
				"nl-BE": "Gang",
				"fr-BE": "Couloir",
			},
		},
		OUTSIDE_DOMAIN: {
			display: {
				"nl-BE": "Buiten domein",
				"fr-BE": "En dehors du domaine",
			},
		},
		PARKING: {
			display: {
				"nl-BE": "Parking",
				"fr-BE": "Parking",
			},
		},
		ROOM: {
			display: {
				"nl-BE": "Kamer",
				"fr-BE": "Chambre",
			},
		},
		TOILET: {
			display: {
				"nl-BE": "Toilet",
				"fr-BE": "Toilette",
			},
		},
		LEGACY_OTHER: {
			display: {
				"nl-BE": "Andere",
				"fr-BE": "Autre",
			},
		},
	},
} as const satisfies CodeSystem;
